import { AxiosResponse } from "axios";

import {
  ISamMedication,
  ISamMedicationsFilters,
  ISamMedicationSummary,
} from "../../@types/admin/AdminMedication";
import { IPaginatedResponse } from "../../@types/PaginatedResponse";
import { api } from "../api";

/**
 * SAM medications admin page (EN-5240): read-only browser over the Belgian SAM
 * packs that SAM organisations' patients search. Server-paginated and
 * server-sorted (~8.7k packs).
 */
export const samMedicationsService = {
  async getMedications(
    filters: ISamMedicationsFilters
  ): Promise<AxiosResponse<IPaginatedResponse<ISamMedication[]>>> {
    return api.get<IPaginatedResponse<ISamMedication[]>>(
      "/Retool/SamMedications",
      {
        params: {
          page: filters.page,
          pageSize: filters.pageSize,
          search: filters.search || undefined,
          active: filters.active,
          hospitalOnly: filters.hospitalOnly,
          language: filters.language,
          sortBy: filters.sortBy,
          sortDescending: filters.sortDescending,
        },
      }
    );
  },

  async getSummary(): Promise<AxiosResponse<ISamMedicationSummary>> {
    return api.get<ISamMedicationSummary>("/Retool/SamMedications/Summary");
  },
};
